import { render, staticRenderFns } from "./prech.vue?vue&type=template&id=495f61b7&"
import script from "./prech.vue?vue&type=script&lang=js&"
export * from "./prech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports